import React, { useRef } from 'react';
import { BiPlus, BiRedo, BiUndo, BiUpload, BiDownload } from 'react-icons/bi';
import { BsEye } from 'react-icons/bs';
import { Button } from '../ui';
import { useBuilderEditor } from '../../features/builder/BuilderEditorContext';
import './builder-shell.scss';

const FloatingToolbar = ({
  onAddQuestion,
  onAddSection,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  onPreview,
}) => {
  const { exportFormJson, importFormJson, openSubsectionModal } = useBuilderEditor();
  const importInputRef = useRef(null);

  const handleImportFileChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (file) importFormJson(file);
  };

  return (
    <div className="builder-floating-toolbar" role="toolbar" aria-label="Form builder actions">
      <Button variant="primary" size="sm" icon={<BiPlus />} onClick={onAddQuestion}>Question</Button>
      <Button variant="secondary" size="sm" icon={<BiPlus />} onClick={onAddSection}>Section</Button>
      <Button variant="secondary" size="sm" icon={<BiPlus />} onClick={openSubsectionModal}>Subsection</Button>
      {/* <span className="builder-floating-toolbar__divider" /> */}
      {/* <Button variant="ghost" size="sm" icon={<BiDownload />} onClick={exportFormJson} aria-label="Export JSON">Export</Button> */}
      {/* <input
        ref={importInputRef}
        type="file"
        accept="application/json"
        style={{ display: 'none' }}
        onChange={handleImportFileChange}
      /> */}
      {/* <Button variant="ghost" size="sm" icon={<BiUpload />} aria-label="Import" onClick={() => importInputRef.current?.click()}>Import</Button> */}
      <span className="builder-floating-toolbar__divider" />
      {/* <Button variant="ghost" size="sm" icon={<BiUndo />} onClick={onUndo} disabled={!canUndo} aria-label="Undo" /> */}
      {/* <Button variant="ghost" size="sm" icon={<BiRedo />} onClick={onRedo} disabled={!canRedo} aria-label="Redo" /> */}
      <Button variant="ghost" size="sm" icon={<BsEye />} onClick={onPreview} aria-label="Preview">Preview</Button>
    </div>
  );
};

export default FloatingToolbar;
